import { HomeCityOutlineIcon } from './HomeCityOutlineIcon';

/**
 * author: Google
 * id 69A854BB-0CC9-4E1B-855E-FD26E9E6D119
 * name home-city-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-city-outline.svg
 * tags
 * - Home Automation 
 * - Places 
 */
export const HouseCityOutlineIcon = HomeCityOutlineIcon;
export default HouseCityOutlineIcon